import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../contexts/LanguageContext';
import profilePic from '../img/profile.png';
import '../styles/ContactBloc.css';

const buttonContactVariants = {
    hover: { scale: 1.1 },
    tap: { scale: 0.95 }
};

const fadeInUp = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
};

const ContactBloc: React.FC = () => {
    const { language } = useContext(LanguageContext)!;

    return (
        <motion.div
            className="contact-bloc-section"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            variants={fadeInUp}
        >
            <motion.img
                src={profilePic}
                alt="Profile Picture"
                className="contact-bloc-pic"
                variants={fadeInUp}
                loading="lazy"
            />
            <motion.p className="contact-bloc-text" variants={fadeInUp}>
                {language === 'fr' ? 'Prêt à travailler ensemble ?' : 'Ready to work together?'}
            </motion.p>
            <motion.div variants={fadeInUp}>
                <Link to="/contact">
                    <motion.button
                        className="contact-bloc-button"
                        whileHover="hover"
                        whileTap="tap"
                        variants={buttonContactVariants}
                    >
                        {language === 'fr' ? 'Contactez-moi' : 'Contact Me'}
                    </motion.button>
                </Link>
            </motion.div>
        </motion.div>
    );
};

export default ContactBloc;
